var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _circle221, _circle222, _circle223, _circle224, _circle225, _circle226, _circle227, _circle228, _circle229, _circle230, _circle231, _circle232, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _circle233, _circle234, _circle235, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeroDefaultBgImage = function SvgHeroDefaultBgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2188,
    height: 603,
    fill: "none",
    role: "presentation"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E341F",
    fillOpacity: 0.2,
    d: "m1332.52 578.507 13.83 13.269-19.04 5.013z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E341F",
    fillOpacity: 0.2,
    d: "m1338.48 599.968-13.83-13.271 19.05-5.01zM1306.47 176.704l9.41 9.023-12.95 3.409z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E341F",
    fillOpacity: 0.2,
    d: "m1310.53 191.297-9.4-9.024 12.94-3.407z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#08457A",
    fillOpacity: 0.2,
    d: "m1708.14 62.406 13.27 12.738-18.28 4.813z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#08457A",
    fillOpacity: 0.2,
    d: "m1713.86 83.008-13.27-12.74 18.28-4.81z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E341F",
    fillOpacity: 0.2,
    d: "m321.474 68.704 9.402 9.023-12.947 3.408z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E341F",
    fillOpacity: 0.2,
    d: "m325.526 83.297-9.401-9.024 12.948-3.407z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F6964",
    fillOpacity: 0.2,
    d: "m1496.47 275.704 9.41 9.023-12.95 3.409z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F6964",
    fillOpacity: 0.2,
    d: "m1500.53 290.297-9.4-9.024 12.94-3.407z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3C954",
    fillOpacity: 0.6,
    d: "m732.207 330.852 9.89 9.49-13.618 3.585z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A2D4",
    fillOpacity: 0.6,
    d: "m965.082 9.568 8.652 8.303-11.914 3.137z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E341F",
    fillOpacity: 0.2,
    d: "M472.352 150.038 459 158.197v-16.076z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.4,
    d: "m1938.35 113.762 9.72 9.324-13.38 3.523z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#065853",
    fillOpacity: 0.5,
    d: "m2034.96 323.787-8.15-7.831 11.23-2.957z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#51309F",
    fillOpacity: 0.2,
    d: "m1289.85 468.805 9.96 9.553-13.71 3.61z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#51309F",
    fillOpacity: 0.2,
    d: "m1294.15 484.253-9.96-9.555 13.71-3.608z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#08457A",
    fillOpacity: 0.2,
    d: "m843.351 484.462 13.581 13.033-18.701 4.924z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#08457A",
    fillOpacity: 0.2,
    d: "m849.204 505.541-13.58-13.036 18.703-4.921zM1366.83 49.535l8.46 8.12-11.65 3.067zM1595.13 366.757l-8.13-7.809 11.2-2.948z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A2D4",
    fillOpacity: 0.3,
    d: "m1843.95 441.41 18.8 18.045-25.89 6.818z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A2D4",
    fillOpacity: 0.3,
    d: "m1852.05 470.598-18.8-18.048 25.9-6.814z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 367,
    cy: 313,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1387,
    cy: 493,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1107,
    cy: 3,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 383,
    cy: 313,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1403,
    cy: 493,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1123,
    cy: 3,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2073,
    cy: 143,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 399,
    cy: 313,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1419,
    cy: 493,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 1139,
    cy: 3,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 2089,
    cy: 143,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 313,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1435,
    cy: 493,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 1155,
    cy: 3,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 2105,
    cy: 143,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 313,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1451,
    cy: 493,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1171,
    cy: 3,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 2121,
    cy: 143,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 447,
    cy: 313,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 1467,
    cy: 493,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 1187,
    cy: 3,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 2137,
    cy: 143,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 463,
    cy: 313,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 1483,
    cy: 493,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 1203,
    cy: 3,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 2153,
    cy: 143,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 313,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 1499,
    cy: 493,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 1219,
    cy: 3,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 2169,
    cy: 143,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 313,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 1515,
    cy: 493,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 1235,
    cy: 3,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 2185,
    cy: 143,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 511,
    cy: 313,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 1531,
    cy: 493,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 1251,
    cy: 3,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 1547,
    cy: 493,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 367,
    cy: 329,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 1387,
    cy: 509,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 1107,
    cy: 19,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 383,
    cy: 329,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 1403,
    cy: 509,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 1123,
    cy: 19,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 2073,
    cy: 159,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 399,
    cy: 329,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 1419,
    cy: 509,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 1139,
    cy: 19,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 2089,
    cy: 159,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 329,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 1435,
    cy: 509,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 1155,
    cy: 19,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 2105,
    cy: 159,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 329,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 1451,
    cy: 509,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 1171,
    cy: 19,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 2121,
    cy: 159,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 447,
    cy: 329,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 1467,
    cy: 509,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 1187,
    cy: 19,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 2137,
    cy: 159,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 463,
    cy: 329,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 1483,
    cy: 509,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 1203,
    cy: 19,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 2153,
    cy: 159,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 329,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 1499,
    cy: 509,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 1219,
    cy: 19,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 2169,
    cy: 159,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 329,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 1515,
    cy: 509,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 1235,
    cy: 19,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 2185,
    cy: 159,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 511,
    cy: 329,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 1531,
    cy: 509,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 1251,
    cy: 19,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 1547,
    cy: 509,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 367,
    cy: 345,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 1387,
    cy: 525,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 1107,
    cy: 35,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 383,
    cy: 345,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 1403,
    cy: 525,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 1123,
    cy: 35,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 2073,
    cy: 175,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 399,
    cy: 345,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 1419,
    cy: 525,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 1139,
    cy: 35,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 2089,
    cy: 175,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 345,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 1435,
    cy: 525,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 1155,
    cy: 35,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 2105,
    cy: 175,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 345,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 1451,
    cy: 525,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 1171,
    cy: 35,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 2121,
    cy: 175,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 447,
    cy: 345,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 1467,
    cy: 525,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 1187,
    cy: 35,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 2137,
    cy: 175,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 463,
    cy: 345,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 1483,
    cy: 525,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 1203,
    cy: 35,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 2153,
    cy: 175,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 345,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 1499,
    cy: 525,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 1219,
    cy: 35,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 2169,
    cy: 175,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 345,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 1515,
    cy: 525,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 1235,
    cy: 35,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 2185,
    cy: 175,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 511,
    cy: 345,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 1531,
    cy: 525,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 1251,
    cy: 35,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 1547,
    cy: 525,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 367,
    cy: 361,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 1387,
    cy: 541,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 1107,
    cy: 51,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 383,
    cy: 361,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 1403,
    cy: 541,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 1123,
    cy: 51,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 2073,
    cy: 191,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 399,
    cy: 361,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 1419,
    cy: 541,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 1139,
    cy: 51,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 2089,
    cy: 191,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 361,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 1435,
    cy: 541,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 1155,
    cy: 51,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 2105,
    cy: 191,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 361,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 1451,
    cy: 541,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 1171,
    cy: 51,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 2121,
    cy: 191,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 447,
    cy: 361,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 1467,
    cy: 541,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 1187,
    cy: 51,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 2137,
    cy: 191,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 463,
    cy: 361,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 1483,
    cy: 541,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 1203,
    cy: 51,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 2153,
    cy: 191,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 361,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 1499,
    cy: 541,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 1219,
    cy: 51,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 2169,
    cy: 191,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 361,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 1515,
    cy: 541,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 1235,
    cy: 51,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 2185,
    cy: 191,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 511,
    cy: 361,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 1531,
    cy: 541,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 1251,
    cy: 51,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 1547,
    cy: 541,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 367,
    cy: 377,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 1387,
    cy: 557,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 1107,
    cy: 67,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 383,
    cy: 377,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 1403,
    cy: 557,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 1123,
    cy: 67,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 2073,
    cy: 207,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 399,
    cy: 377,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 1419,
    cy: 557,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 1139,
    cy: 67,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 2089,
    cy: 207,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 377,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 1435,
    cy: 557,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 1155,
    cy: 67,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 2105,
    cy: 207,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 377,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 1451,
    cy: 557,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 1171,
    cy: 67,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 2121,
    cy: 207,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 447,
    cy: 377,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 1467,
    cy: 557,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 1187,
    cy: 67,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    cx: 2137,
    cy: 207,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    cx: 463,
    cy: 377,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    cx: 1483,
    cy: 557,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    cx: 1203,
    cy: 67,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    cx: 2153,
    cy: 207,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 377,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    cx: 1499,
    cy: 557,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    cx: 1219,
    cy: 67,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    cx: 2169,
    cy: 207,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 377,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    cx: 1515,
    cy: 557,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    cx: 1235,
    cy: 67,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    cx: 2185,
    cy: 207,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    cx: 511,
    cy: 377,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    cx: 1531,
    cy: 557,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    cx: 1251,
    cy: 67,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    cx: 1547,
    cy: 557,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    cx: 367,
    cy: 393,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    cx: 1387,
    cy: 573,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    cx: 383,
    cy: 393,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    cx: 1403,
    cy: 573,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    cx: 2073,
    cy: 223,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    cx: 399,
    cy: 393,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    cx: 1419,
    cy: 573,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    cx: 2089,
    cy: 223,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 393,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    cx: 1435,
    cy: 573,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    cx: 2105,
    cy: 223,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 393,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    cx: 1451,
    cy: 573,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    cx: 2121,
    cy: 223,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    cx: 447,
    cy: 393,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    cx: 1467,
    cy: 573,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    cx: 2137,
    cy: 223,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    cx: 463,
    cy: 393,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    cx: 1483,
    cy: 573,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    cx: 2153,
    cy: 223,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 393,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    cx: 1499,
    cy: 573,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    cx: 2169,
    cy: 223,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    cx: 495,
    cy: 393,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    cx: 1515,
    cy: 573,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    cx: 2185,
    cy: 223,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    cx: 511,
    cy: 393,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    cx: 1531,
    cy: 573,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    cx: 1547,
    cy: 573,
    r: 3,
    fill: "#1A2333",
    fillOpacity: 0.1
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.5,
    cy: 354.5,
    r: 3.5,
    fill: "#285053",
    fillOpacity: 0.5
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    cx: 947,
    cy: 400,
    r: 4,
    fill: "#49292C",
    fillOpacity: 0.2
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 238,
    r: 4,
    fill: "#49292C",
    fillOpacity: 0.2
  })), _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 110,
    r: 4,
    fill: "#49292C",
    fillOpacity: 0.5
  })), _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    cx: 1520,
    cy: 437,
    r: 4,
    fill: "#132F4C",
    fillOpacity: 0.5
  })), _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    cx: 1695,
    cy: 227,
    r: 4,
    fill: "#132F4C",
    fillOpacity: 0.5
  })), _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    cx: 1552,
    cy: 126,
    r: 4,
    fill: "#B1A2D4",
    fillOpacity: 0.4
  })), _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    cx: 1989,
    cy: 344,
    r: 4,
    fill: "#49292C"
  })), _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    cx: 1133,
    cy: 441,
    r: 4,
    fill: "#132F4C",
    fillOpacity: 0.5
  })), _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    cx: 591,
    cy: 174,
    r: 4,
    fill: "#34262F",
    fillOpacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.3,
    d: "m1766.93 343.197-8.12-8.345-2.81 2.735 8.12 8.345zM798.933 294.665l-8.121-8.345-2.811 2.736 8.121 8.345z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.3,
    d: "m1764.12 345.929 2.74 2.812 2.81-2.734 5.53-5.386-2.73-2.808 2.8-2.735-8.34 8.116zM796.124 297.398l2.736 2.812 2.809-2.734 5.531-5.386-2.735-2.809 2.808-2.734-8.341 8.116z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.3,
    d: "m1775.2 340.62 8.12 8.34-2.74-2.808 2.81-2.735-5.39-5.531-2.73-2.808-2.81 2.734zM807.196 292.089l8.12 8.34-2.734-2.809 2.808-2.734-5.386-5.532-2.735-2.808-2.808 2.735z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.3,
    d: "m1783.32 348.96 2.81-2.73 5.53-5.386-2.74-2.813 2.81-2.734-8.34 8.121-2.81 2.734zM815.317 300.429l2.811-2.73 5.531-5.386-2.737-2.813 2.808-2.734-8.339 8.12-2.808 2.735z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.3,
    d: "m1791.66 340.843 5.38 5.532 2.81-2.735-8.12-8.344-2.81 2.735zM823.659 292.312l5.386 5.532 2.808-2.735-8.123-8.344-2.808 2.735z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.3,
    d: "m1797.04 346.374 2.74 2.808 11.15-10.857-2.73-2.808-8.35 8.123zM829.045 297.843l2.734 2.808 11.152-10.857-2.734-2.808-8.344 8.123z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.4,
    d: "m511.595 26.413-9.943-10.218-3.442 3.35 9.943 10.217z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.4,
    d: "m508.153 29.756 3.351 3.444 3.438-3.348 6.773-6.595-3.349-3.438 3.439-3.348-10.214 9.937z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.4,
    d: "m521.717 23.258 9.943 10.21-3.349-3.437 3.439-3.349-6.595-6.772-3.348-3.439-3.438 3.349z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.4,
    d: "m531.66 33.468 3.441-3.343 6.773-6.595-3.351-3.443 3.438-3.349-10.211 9.943-3.438 3.348z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.4,
    d: "m541.872 23.53 6.595 6.773 3.438-3.348-9.946-10.216-3.438 3.348zM548.467 30.305l3.348 3.438 13.654-13.294-3.348-3.438-10.216 9.945z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#51309F",
    fillOpacity: 0.3,
    d: "M958.212 251.839 957 256.211l6.705 1.859 1.212-4.372z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0C341",
    fillOpacity: 0.2,
    d: "m1414.21 377.839-1.21 4.372 6.7 1.859 1.22-4.372z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#065853",
    fillOpacity: 0.3,
    d: "M235.468 493.86 234 499.152l8.116 2.251 1.468-5.292z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#51309F",
    fillOpacity: 0.3,
    d: "m969.295 254.913-1.213 4.372 6.705 1.86 1.212-4.373z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0C341",
    fillOpacity: 0.2,
    d: "m1425.29 380.913-1.21 4.372 6.71 1.86 1.21-4.373z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#065853",
    fillOpacity: 0.3,
    d: "m248.882 497.579-1.468 5.292 8.117 2.251 1.467-5.293z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#51309F",
    fillOpacity: 0.3,
    d: "M963.198 258.079 961 264.787l5.171 1.213 2.198-6.708 1.433-4.371 2.198-6.708-5.171-1.213-2.198 6.703z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0C341",
    fillOpacity: 0.2,
    d: "m1419.2 384.079-2.2 6.708 5.17 1.213 2.2-6.708 1.43-4.371 2.2-6.708-5.17-1.213-2.2 6.703z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#065853",
    fillOpacity: 0.3,
    d: "m242.198 501.411-2.198 8.12 5.171 1.469 2.198-8.12 1.433-5.291 2.198-8.12-5.171-1.469-2.198 8.114z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3C954",
    fillOpacity: 0.6,
    d: "m243.793 185.15-9.89-9.49 13.618-3.585z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1A2D4",
    fillOpacity: 0.6,
    d: "m10.918 506.434-8.652-8.303 11.914-3.137z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#08457A",
    fillOpacity: 0.2,
    d: "m132.649 31.54-13.581-13.033 18.701-4.924z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#08457A",
    fillOpacity: 0.2,
    d: "m126.796 10.461 13.58 13.036-18.703 4.92z"
  })), _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    cx: 392.5,
    cy: 161.502,
    r: 3.5,
    fill: "#285053",
    fillOpacity: 0.5,
    transform: "rotate(-180 392.5 161.502)"
  })), _circle234 || (_circle234 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 116.002,
    r: 4,
    fill: "#49292C",
    fillOpacity: 0.2,
    transform: "rotate(-180 29 116.002)"
  })), _circle235 || (_circle235 = /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 406.002,
    r: 4,
    fill: "#49292C",
    fillOpacity: 0.5,
    transform: "rotate(-180 202 406.002)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.3,
    d: "m165.067 279.831 8.121 8.345 2.811-2.736-8.121-8.345z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.3,
    d: "m167.876 277.098-2.736-2.812-2.809 2.735-5.531 5.386 2.735 2.808-2.808 2.734 8.341-8.116z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.3,
    d: "m156.804 282.407-8.12-8.339 2.734 2.808-2.808 2.734 5.386 5.532 2.735 2.808 2.808-2.735z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.3,
    d: "m148.683 274.067-2.811 2.73-5.531 5.386 2.737 2.813-2.808 2.734 8.339-8.12 2.808-2.735z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.3,
    d: "m140.341 282.184-5.386-5.532-2.808 2.735 8.123 8.344 2.808-2.735z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2333",
    fillOpacity: 0.3,
    d: "m134.955 276.653-2.734-2.808-11.152 10.857 2.734 2.808 8.344-8.122z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#51309F",
    fillOpacity: 0.3,
    d: "M17.788 264.163 19 259.791l-6.705-1.859-1.212 4.372zM6.705 261.089l1.213-4.372-6.705-1.86-1.212 4.372z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#51309F",
    fillOpacity: 0.3,
    d: "M12.803 257.923 15 251.215l-5.171-1.213-2.198 6.708-1.433 4.37L4 267.789l5.171 1.213 2.198-6.703z"
  })));
};
export default SvgHeroDefaultBgImage;